import { useEffect, useRef, useState } from "preact/hooks";
import { createRef } from "preact";
import type { FC } from "preact/compat";
import { useIntersectionTracker } from "@hooks/useIntersectionTracker";

export interface TestimonialsProps {
  testimonials: {
    quote: string;
    attributed: string;
    tag: string;
  }[];
}
export const TestimonialMobile: FC<TestimonialsProps> = ({ testimonials }) => {
  const [items] = useState(testimonials);
  const container = useRef<HTMLDivElement>(null);
  //add a ref to each item element
  const itemsRef = useRef(
    Array.from({ length: testimonials?.length }, (_) => createRef()),
  );

  //add a ref to each signal element
  const signalsRef = useRef(
    Array.from({ length: testimonials?.length }, (_) => createRef()),
  );

  const listRef = useRef<HTMLElement>(null);

  const activateSignal = (intersectingIndex: Number) => {
    signalsRef.current.forEach((signal, i) => {
      if (i === intersectingIndex) {
        signal.current?.classList.remove("bg-neutral-400");
        signal.current?.classList.add("bg-gt-lilac");
      } else {
        signal.current?.classList.add("bg-neutral-400");
        signal.current?.classList.remove("bg-gt-lilac");
      }
    });
  };

  const theInObHook = useIntersectionTracker(
    {
      targetRef: itemsRef,
      root: listRef.current,
      threshold: 0.6,
    },
    activateSignal,
  );

  useEffect(() => {
    theInObHook;
  }, []);

  const handleClick = (index: number) => {
    return () => {
      if (container.current) {
        container.current.style.scrollBehavior = "smooth";
        const snapLengthX = Math.round(
          container.current.scrollWidth / testimonials.length,
        );
        container.current.scrollLeft = snapLengthX * index;
      }
    };
  };

  return (
    <>
      <div
        class="h-full overflow-x-scroll w-11/12 flex"
        style={{
          scrollbarWidth: "none",
          scrollSnapType: "x mandatory",
        }}
        ref={container}
      >
        {items.map((_testimonial, index) => {
          return (
            <div
              style={{
                flex: "0 0 100%",
                scrollSnapAlign: "start",
                scrollSnapStop: "always",
              }}
              class="w-full flex justify-center items-center relative"
              key={index}
              ref={itemsRef.current[index]}
            >
              <div class="w-full md:w-2/3 flex-col items-center justify-center">
                <p class="flex items-center text-center text-base">
                  {`“${_testimonial.quote}”`}
                </p>
                <div class="mt-6 flex justify-center">
                  <p class="text-base text-center font-medium">
                    {_testimonial.attributed}
                  </p>
                  &nbsp;
                  <p class="font-normal text-base text-center">
                    {_testimonial.tag}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div class="flex w-[54px] justify-between">
        {items.map((_testimonial, index) => {
          return (
            <div
              key={index}
              ref={signalsRef.current[index]}
              class="h-2.5 w-2.5 rounded-full bg-neutral-400 cursor-pointer"
              onClick={handleClick(index)}
            />
          );
        })}
      </div>
    </>
  );
};
